/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'

import { Alert, Box, Button, Collapse, Paper, Typography } from '@mui/material'

import svg from 'assets/svg/FE_Error.svg'

export const ErrorBoundaryMessage = ({ error, resetErrorBoundary }) => {
  const location = useLocation()

  const [open, setOpen] = useState(false)
  const [locationChange, setLocationChange] = useState(null)
  const memoLocation = useMemo(() => location, [locationChange])

  useEffect(() => {
    if (location?.pathname !== memoLocation?.pathname) {
      resetErrorBoundary()
      setLocationChange(location)
    }
  }, [location])

  const { t } = useTranslation()

  return (
    <Paper
      sx={{
        padding: '0 5rem 3rem',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '50rem',
        width: '100%',
        margin: '0 auto 2rem ',
      }}
    >
      {/* IMAGE */}
      <Box
        component='img'
        sx={{
          height: 'auto',
          width: '75%',
          margin: '0 auto',
        }}
        alt='not found'
        src={svg}
      />
      
      {/* MESSAGE */}
      <Typography
        variant='h5'
        align='center'
        sx={{ marginBottom: '0', color: '#000' }}
      >{`${t('errors.missing-data')}.`}</Typography>
      <Typography
        variant='h5'
        align='center'
        sx={{ marginTop: '0', color: '#000', marginBottom: '2rem' }}
      >{`${t('errors.on-it')}`}</Typography>
      {/* SHOW ERROR */}
      <Button
        variant='contained'
        color={open ? 'error' : 'primary'}
        onClick={() => setOpen(!open)}
        sx={{ width: '80%', margin: '0 auto', textTransform: 'uppercase', color: '#000' }}
        >
        {`${t('errors.show-log')}`}
        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </Button>

      {/* SHOW ERROR */}
      <Collapse in={open} timeout='auto'>
        <Alert severity='error' sx={{ width: '80%', margin: '0 auto 2rem'}}>{error.message}</Alert>
      </Collapse>

      {/* GO BACK */}
      <Button
        variant='contained'
        color='white'
        onClick={() => window.location.href = '/'}
        sx={{ width: '80%', margin: '1rem auto 0', textTransform: 'uppercase' }}
      >
        {`${t('common.back')}`}
      </Button>
    </Paper>
  )
}
